export default __webpack_public_path__ + "static/design_reversed-7174c42eb7e5d77ccc2dd5df21377e18.mp4";